import { useSelector } from 'react-redux';
import { useState } from 'react';
import { formatRupiah, isEmptyData } from '../../../utils/helper';
import Footer from '../../../components/Footer';
import { DiscountIcon } from '../../../utils/svg';
import useNavigation from '../../../hook/useNavigation';
import NamePhone from '../Member/NamePhone';

const Checkout = () => {
	const navigate = useNavigation();
	const { cart } = useSelector((store) => store?.cart);
	const user = useSelector((store) => store?.user || {});
	const [showNamePhoneModal, setShowNamePhoneModal] = useState(false);

	const handleClick = () => {
		if (isEmptyData(user?.token)) {
			setShowNamePhoneModal(true);
			return;
		}

		navigate.push('/ufood-x/summary');
	};

	return (
		<>
			<Footer position='fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl !z-[6]' id='cart'>
				<div
					className={`bg-white p-4 shadow-custom transition-transform duration-1000 ease-in-out ${cart?.totalItem ? 'translate-y-0 relative' : 'translate-y-full hidden'
						}`}
				>
					<div className='items-center hidden'>
						<DiscountIcon />
						<div className='pl-2 text-gray-900 text-xs'>
							Yay, kamu menghemat 10k. Tambahkan lebih banyak dan hemat hingga 50k!
						</div>
					</div>

					<button
						className='w-full bg-[var(--rose-violet)] text-white flex justify-between font-normal text-sm p-3 border-0 items-center'
						onClick={handleClick}
						id='merchant_item_in_cart'
					>
						<div>{cart?.totalItem} item di keranjang</div>
						<div>{formatRupiah(parseInt(cart?.subTotal || 0))}</div>
					</button>
				</div>
			</Footer>

			{showNamePhoneModal && (
				<NamePhone onClose={() => setShowNamePhoneModal(false)} />
			)}
		</>
	);
};

export default Checkout;